import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import App from './App';
import store from './store';
import {Provider} from 'react-redux';
import history from './history';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}><App /></Router>
    </Provider>, 
  document.getElementById('root')
);
